import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Button, notification } from 'antd';

const defaultProps = {
  theme: '',
  exportData: () => {},
  handleCancel: () => {}
};

const propTypes = {
  objectType: PropTypes.string.isRequired,
  theme: PropTypes.string,
  criteriaAndLogic: PropTypes.object.isRequired,
  selectedFields: PropTypes.array.isRequired,
  exportData: PropTypes.func,
  handleCancel: PropTypes.func
};

const ExportAction = ({
  intl,
  objectType,
  theme,
  criteriaAndLogic,
  selectedFields,
  exportData,
  handleCancel
}) => {
  const { formatMessage } = intl;

  const errorMsg = key => notification.error({
    duration: 3,
    message: formatMessage({ id: `global.errors.${key}` }),
  });

  const checkCriteriaAndLogic = () => {
    const { criteria, logic } = criteriaAndLogic;
    if (!_.isArray(criteria.criteria)) return false;
    if (criteria && criteria.criteria && criteria.criteria.length > 0 && _.isEmpty(logic)) {
      errorMsg('filterNumRequired');
      return false;
    }
    const isAnyInvalid = criteria.criteria.some(c => !c.isValid());
    if (isAnyInvalid) {
      errorMsg('fieldAndConditionRequired');
      return false;
    }
    return true;
  };

  const checkSelectdFields = () => {
    if (selectedFields.length < 1) {
      errorMsg('selectionRequired');
      return false;
    }
    return true;
  };

  const handleExporting = () => {
    if (!checkCriteriaAndLogic() || !checkSelectdFields()) return;
    const { criteria, logic } = criteriaAndLogic;

    const selectors = selectedFields.map(field => field.field_name);
    const filters = criteria.criteria.map(c => c.toApi());

    exportData({
      object_type: objectType,
      export_file_type: 'csv',
      export_setup_properties: {
        selectors,
        filters,
        condition_logic: logic
      },
    });
  };

  return (
    <React.Fragment>
      <Button className={`${theme}-theme-btn`} onClick={handleExporting}>
        {formatMessage({ id: 'page.ObjectExport.startExporting' })}
      </Button>
      <Button onClick={handleCancel}>
        {formatMessage({ id: 'global.ui.button.cancel' })}
      </Button>
    </React.Fragment>
  );
};

ExportAction.defaultProps = defaultProps;
ExportAction.propTypes = propTypes;

export default injectIntl(ExportAction);



// WEBPACK FOOTER //
// ./src/views/Setup/ObjectExport/component/ExportAction.jsx